export default "__VITE_ASSET__c906df65__"